// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__Bi7yy","title":"AfterFrontImage_title__hiZ0b"};